import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { mapMovementSignatureForHighcharts } from '../../mappers/model/GroupedBarChartWithLineMapper';
import { useSelector } from "react-redux";

const HighchartsGroupedBar = ({ dataIn, teamName, stat = '', position = [], player_group = [], 
  sessions = [], enableDrillDown = false, playerId = null }) => {
  const {
    info: {
      movement_sig_chart_mapping,
      team_colors
    },
  } = useSelector(({ team }) => team);

  const options = mapMovementSignatureForHighcharts(
   {
      data: dataIn.data, 
      mapping: movement_sig_chart_mapping, 
      teamColors: team_colors, 
      teamName,
      stat,
      position,
      player_group,
      sessions,
      enableDrillDown,
      playerId
   }
  );

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default HighchartsGroupedBar;